import { RouteRecordRaw } from "vue-router";

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: "/home",
    name: "Landing",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/Index.vue"),
  },
  {
    path: "/about-us",
    name: "LandingAboutUs",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/About-us.vue"),
  },
  {
    path: "/pricing",
    name: "LandingPricing",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/Pricing.vue"),
  },
  {
    path: "/blogs",
    name: "LandingBlogs",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/Blogs/Index.vue"),
  },
  {
    path: "/blogs/:slug",
    name: "LandingBlogDetail",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/Blogs/BlogDetail.vue"),
  },
  {
    path: "/contact-us",
    name: "LandingContactUs",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/Contacts.vue"),
  },
  {
    path: "/history",
    name: "LandingHistory",
    meta: {
      layout: "landing",
    },
    component: () => import("@/modules/Landing/pages/History.vue"),
  },
];

export default routes;
